/**
 * @desc 事件详情
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.EventDetailResponse>> {
  return defHttp.get({
    url: '/web/event/{id}',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.EventDetailResponse>> {
  return defHttp.get({
    url: '/mock/web/event/{id}',

    params,
  });
}
